<template>
  <div class="page project-container">
    <LayoutContainer>
      <div class="page-header project-create-header">
        <h1 class="title">สร้างโปรเจกต์ใหม่</h1>
      </div>
      <div class="page-content">
        <div class="create-project-container">
          <Section>
            <div class="section-body">
              <div class="row">
                <div class="col-md-6">
                  <form v-on:submit.prevent="onCreateProject">
                    <FormGroup :errorMessage="error.title">
                      <h5>Project Name</h5>
                      <TextInput
                        :name="'title'"
                        :placeholder="'e.g. ByteArk Lighthouse'"
                        :value="project.title"
                        :customClass="createInputClass(error, 'title')"
                        @change="onChange"
                        @blur="generateSlug" />
                    </FormGroup>
                    <FormGroup :errorMessage="error.projectIdPrefix" class="w-25">
                      <h5>Project ID</h5>
                      <label for="projectIdPrefix">ชื่อ ID ของโปรเจคต์จะถูกใช้เพื่อเป็น referer
                      ในการรับส่งข้อมูลสถิติระหว่างแอพพลิเคชั่นของท่านกับ Lighthouse</label>
                      <TextInputGroup
                        :label="'-xxxxxxxxxxx'"
                        :labelType="'suffix'"
                        :name="'projectIdPrefix'"
                        :placeholder="'byteark-lighthouse'"
                        :value="project.projectIdPrefix"
                        :customClass="createInputClass(error, 'projectIdPrefix')"
                        :classWidth="'width-50'"
                        @change="onChange"/>
                    </FormGroup>
                    <FormFooter>
                      <Button
                        type="submit"
                        :buttonClass="'btn-primary'"
                        :disabled="!isValid">
                        Create
                      </Button>
                      <div class="spinner-border spinner-border-sm ml-3" role="status" v-if="state.isLoading" />
                    </FormFooter>
                  </form>
                </div>
              </div>
            </div>
          </Section>
        </div>
      </div>
    </LayoutContainer>
  </div>
</template>

<script>
import _ from 'lodash';
import { createProject } from '@/project/api';
import generateLink from '@/utils/generateLink';
import parserFormData from '@/utils/formUtils';
import FormGroup from '@/form/FormGroup.vue';
import FormFooter from '@/form/FormFooter.vue';
import Button from '@/form/Button.vue';
import TextInput from '@/form/TextInput.vue';
import TextInputGroup from '@/form/TextInputGroup.vue';
import Section from '@/components/Section.vue';
import LayoutContainer from '@/layout/LayoutContainer.vue';

export default {
  mixins: [generateLink, parserFormData],
  components: {
    FormGroup,
    FormFooter,
    Button,
    TextInput,
    TextInputGroup,
    Section,
    LayoutContainer,
  },
  data() {
    return {
      project: {
        title: '',
        projectIdPrefix: '',
      },
      error: {},
      state: {
        isSlugChanged: false,
        isLoading: false,
      },
    };
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
    isValid() {
      return this.project.title && this.project.projectIdPrefix;
    },
  },
  create() {
    this.error = _.cloneDeep(this.project);
  },
  methods: {
    onChange(event) {
      const { name, value } = event.target;
      Object.assign(this.project, { [name]: value });
    },
    generateSlug() {
      const name = this.project.title;
      if (name && !this.state.isSlugChanged) {
        this.project.projectIdPrefix = name.toLowerCase();
      }
    },
    async onCreateProject() {
      this.state.isLoading = true;
      try {
        const response = await createProject(this.project);
        this.state.isLoading = false;
        this.$router.push(`/${this.teamName}/projects/${response.data.projectId}/settings`);
        await this.$store.dispatch('addProject', response.data);
      } catch (error) {
        this.error = error.response.data;
        this.state.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
</style>
